import React, { useEffect, useState, useRef } from "react";
import { useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { makeAjax, respStatus, showMessage, url } from "../../helpers/global_helper";
import useArrowsVisibility from "../LobbyContent/SubComponents/useArrowsVisibility";
import ScrollArrows from "../LobbyContent/SubComponents/ScrollArrows";
import Versi_WAP from "../LobbyContent/MobileDesign/FourDMo/Versi_WAPP_mo/Versi_WAP_mo";
import festiveImg1 from "../../assets/images/FestiveTheme/deer.svg";
import festiveImg2 from "../../assets/images/FestiveTheme/snow-man-web.svg";
const Sidebar = () => {
  const device = useSelector((state) => state.CommonConfig.device_type);
  const app_type = useSelector((state) => state.CommonConfig.app_type);
  const gameId = useSelector((state) => state.CommonConfig.gameId);
  const location = useLocation();
  const navigate = useNavigate();

  const tabsElement = useRef(null);
  const subGamesRef = useRef(null);

  const { showLeftArrow, showRightArrow, scrollTabs } = useArrowsVisibility(tabsElement);
  const gameType = useSelector((state) => state.CommonConfig.gameType);

  const [activeState, setActiveState] = useState(
    window.location.pathname === "/"
      ? "Four_D"
      : localStorage.getItem("activeState")
  );
  const [filteredMenuItems, setFilteredMenuItems] = useState([]);
  const [filteredMenuItems1, setFilteredMenuItems1] = useState([]);

  useEffect(() => {
    localStorage.setItem("activeState", activeState);
  }, [activeState]);

  const handleLinkClick = (e, code) => {
    e.preventDefault(); // Prevent default navigation
    navigate(`/game/${code}`); // Trigger the navigation manually
  };

  const menuItem = [
    { name: "Quick Buy", code: "Quick_Buy", subgame_id: "41" },
    { name: "4D / 3D / 2D", code: "Four_D", subgame_id: "0" },
    { name: "3D Depan", code: "ThreeDDepan", subgame_id: "0" },
    { name: "2D Depan", code: "TwoDDepan", subgame_id: "0" },
    { name: "2D Tengah", code: "TwoDTengah", subgame_id: "0" },
    // { name: "Bolak Balik", code: "bolak_balik", subgame_id: "0" },
    { name: "Colok Bebas", code: "Colok_Bebas", subgame_id: "4" },
    { name: "Colok Bebas 2D", code: "Colok_Bebas_2D", subgame_id: "5" },
    { name: "Colok Jitu", code: "Colok_Jitu", subgame_id: "7" },
    { name: "Colok Naga", code: "Colok_Naga", subgame_id: "6" },
    { name: "50 : 50", code: "Fifty_Fifty", subgame_id: "10" },
    { name: "50 : 50 2D", code: "Fifty_Fifty_2D", subgame_id: "42" },
    { name: "Macau Shio", code: "Macau_Shio", subgame_id: "46" },
    { name: "Shio", code: "Shio", subgame_id: "11" },
    { name: "Tengah Dasar", code: "Tengah_Dasar", subgame_id: "" },
    { name: "Kombinasi", code: "Kombinasi", subgame_id: "14" },
    { name: "Silang Kembang", code: "Silang_Kembang", subgame_id: "" },
    // { name: "BBFS", code: "Bbfs", subgame_id: "0" },
    // { name: "Pola Tarung", code: "pola_tarung", subgame_id: "0" },
  ];

  const menuItem1 = [
    // { name: "Bolak Balik", code: "bolak_balik", subgame_id: "0" },
    { name: "BBFS", code: "Bbfs", subgame_id: "0" },
    { name: "Pola Tarung", code: "pola_tarung", subgame_id: "0" },
  ];

  const filteredMenu =
    (device === "Desktop" || device == undefined)
      // ? ((device !== "Mobile" && app_type === "desktop") ? menuItem.filter((item) => item.code !== "ThreeDDepan" && item.code !== "TwoDDepan" && item.code !== "TwoDTengah") : menuItem )
      ? menuItem
      : menuItem;

  const filteredMenu1 =
    app_type === "desktop"
      ? menuItem1.filter((item) => item.code !== "bolak_balik")
      : menuItem1;

  useEffect(() => {
    const reqData = { gameId };

    makeAjax(url.TOGEL_API.getSubGameStatus, reqData, url.TOGEL_MS_EXT)
      .then((response) => {
        if (response.status !== respStatus["SUCCESS"]) {
          showMessage(response);
          return;
        }
        let resp = response.data;
        const filteredMenuItems = filteredMenu.filter((item) => {
          const subgame = resp.find((sub) => sub.subgame_id == item.subgame_id);
          return subgame && subgame.status === 1;
        });

        const filteredMenuItems1 = filteredMenu1.filter((item) => {
          const subgame = resp.find((sub) => sub.subgame_id == item.subgame_id);
          return subgame && subgame.status === 1;
        });

        setFilteredMenuItems(filteredMenuItems);
        setFilteredMenuItems1(filteredMenuItems1);
      })
      .catch((error) => {
        console.error("Failed to fetch subgame status", error);
      });
  }, [gameId, app_type, device]);

  useEffect(() => {
    const sidebarElement = document.querySelector(".sidebar ul");
    if (sidebarElement) {
      sidebarElement.scrollLeft = 0;
    }
    navigate("/");
  }, [gameId]);

  const currentStep = useSelector((state) => state.paginationData.currentStep)

  useEffect(() => {
    // if ((device === "Mobile" || device === "Desktop" || device === "Tablet") && (currentStep === 2 || currentStep === 3 ||currentStep === 6 || currentStep === 7)) {
    if ((device === "Mobile" || device === "Desktop" || device === "Tablet") && (currentStep === 1) &&
      subGamesRef.current) {
      subGamesRef.current.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }
  }, [currentStep, device]);

  return (
    <div
      // className="sidebar"
      className={`sidebar ${currentStep === 1 ? "disabled" : ""}`}
      ref={subGamesRef}
    >
      {device === "Mobile" && (
        <>
          <ScrollArrows
            showLeftArrow={showLeftArrow}
            showRightArrow={showRightArrow}
            scrollTabs={scrollTabs}
          />
        </>
      )}

      <ul ref={tabsElement} className={`custom-tooltip-wrapper ${currentStep === 1 ? "highlighted" : ""}`}>
        {(filteredMenuItems).map((item, key) => (
          <li key={key}>
            <Link
              to={`/game/${item.code}`}
              className={
                (location.pathname === "/" && item.code === "Four_D") ||
                  location.pathname === `/game/${item.code}`
                  ? "sidebar-button active"
                  : "sidebar-button"
              }
              rel="noopener noreferrer nofollow"
            >
              <div>{item.name}</div>
            </Link>
          </li>
        ))}
      </ul>
      {device === "Mobile" && (<div className="sidebar_gametype"><span className="festive-img-1"></span><span className="chinese-img-1"></span>Generate<span className="festive-img-2"></span><span className="chinese-img-"></span></div>)}
      {device === "Mobile" && (
        <>
          <div className="tab2_container" style={{ display: "flex", justifyContent: "space-between" }}>
            <ul ref={tabsElement}>
              {filteredMenuItems1.map((item, key) => (
                <li key={key}>
                  <a
                    href={`/game/${item.code}`}  // Using <a> tag to allow for manual control
                    onClick={(e) => handleLinkClick(e, item.code)}  // Handle click manually
                    className={
                      (location.pathname === "/" && item.code === "Four_D") ||
                        location.pathname === `/game/${item.code}`
                        ? "sidebar-button active"
                        : "sidebar-button"
                    }
                    rel="noopener noreferrer"
                  >
                    <div>{item.name}</div>
                  </a>
                </li>
              ))}
              <li><Versi_WAP /></li>
            </ul>

          </div>

        </>
      )}
    </div>
  );
};

export default Sidebar;
